module.exports = __webpack_public_path__ + "img/xiaozi_yixie.d695f3b6.png";